const BOARD_SIZE = 8;

const initializeBlocks = () => {
    const initBlocks = []
    for (let y = 0; y < BOARD_SIZE; y++) {
        for (let x = 0; x < BOARD_SIZE; x++) {
            const block = {
                x: x,
                y: y,
                id: `${x}.${y}`,
                highlighted: false,
                isBlack: ((x + y) % 2 === 0)
            }
            initBlocks.push(block);
        }
    }

    return initBlocks;
}

const initializePieces = () => {
    const initPieces = []
    // Black pieces (top 3 rows, only on black squares)
    for (let y = 0; y < 3; y++) {
        for (let x = 0; x < BOARD_SIZE; x++) {
            if ((x + y) % 2 === 0) {
                initPieces.push({
                    id: `black-${x}-${y}`,
                    x,
                    y,
                    playerType: 'black',
                    source: "black",
                    promoted: false,
                    captured: false,
                    selected: false,
                });
            }
        }
    }

    // White pieces (bottom 3 rows, only on black squares)
    for (let y = 5; y < BOARD_SIZE; y++) {
        for (let x = 0; x < BOARD_SIZE; x++) {
            if ((x + y) % 2 === 0) {
                initPieces.push({
                    id: `white-${x}-${y}`,
                    x,
                    y,
                    playerType: 'white',
                    source: "white",
                    promoted: false,
                    captured: false,
                    selected: false,
                });
            }
        }
    }

    return initPieces;
}

// Initial state
export const initialState = {
    blocks: initializeBlocks(),
    pieces: initializePieces(),
    capturedPieces: [],
    selectedPiece: null,
    turn: 'white',
    ongoingChainCapture: false,
    result: null,
    moveHistory: [],
};